import {
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { FC, RefObject, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import downloadFile from 'presentation/utils/downloadFile';

interface Props {
  name: string;
  url: string;
  onClose: () => void;
  finalFocusRef: RefObject<HTMLButtonElement>;
}

const ChatMessageImageViewer: FC<Props> = ({
  name,
  url,
  onClose,
  finalFocusRef,
}) => {
  const { t } = useTranslation();
  const [failedImageUrl, setFailedImageUrl] = useState<string | null>(null);
  const downloadRef = useRef<HTMLButtonElement>(null);

  return (
    <Modal
      isOpen
      onClose={onClose}
      size="full"
      initialFocusRef={downloadRef}
      finalFocusRef={finalFocusRef}
    >
      <ModalOverlay />
      <ModalContent
        h="100vh"
        minH={0}
        borderRadius={0}
        sx={{ '@supports (height: 100dvh)': { height: '100dvh' } }}
      >
        <ModalHeader flexShrink={0} pr="56px">
          <Flex alignItems="center" gap={3} flexWrap="wrap">
            <Text flex="1" minW={0} overflowWrap="anywhere">
              {name}
            </Text>
            <Button
              ref={downloadRef}
              flexShrink={0}
              onClick={() => downloadFile(url)}
            >
              {t('download')}
            </Button>
          </Flex>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          display="flex"
          alignItems="center"
          justifyContent="center"
          flex="1"
          minH={0}
          pb={6}
        >
          {failedImageUrl === url ? (
            <Text role="alert">
              {t('somethingWentWrongPleaseContactSupport')}
            </Text>
          ) : (
            <Image
              ignoreFallback
              src={url}
              alt={name}
              w="100%"
              h="100%"
              objectFit="contain"
              onError={() => setFailedImageUrl(url)}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ChatMessageImageViewer;
